import { retryLazyImport } from '@/helpers/retry-lazy-import.js';
import i18n from '@/plugins/i18n.js';

const UserSettingsPage = retryLazyImport(() => import('@/modules/auth/UserSettingsPage.vue'));
const CompanySelectPage = retryLazyImport(() => import('@/modules/auth/CompanySelectPage.vue'));

export default [
  {
    path: '/settings',
    name: 'settings',
    component: UserSettingsPage,
    meta: {
      requiresAuth: true,
      title: () => i18n.global.t('routes.pageTitles.userSettings'),
      hideSidebar: false
    }
  },
  {
    path: '/settings/company',
    name: 'settings.company',
    component: CompanySelectPage,
    meta: {
      requiresAuth: true,
      title: () => i18n.global.t('routes.pageTitles.selectCompany'),
      hideSidebar: false
    }
  }
];
